export default __webpack_public_path__ + "static/media/bw-reaction-speed-tutorial-pop-up-step-1.9b2204f4.svg";